import "./DepartureItem.css";
import { useEffect, useRef, useState } from "react";
import { getJourney } from "./ServerUtils";
import JourneyStops from "./JourneyStops";
import ScrollableTrain from "./ScrollableTrain.js";
import TrainOnPlatform from "./TrainOnPlatform.js";

export default function DepartureItem({partialData, thisStationCode}){
    const [data, setData] = useState(null);
    const [platform, setPlatform] = useState(null);
    const [viaRecognizable, setViaRecognizable] = useState(undefined);
    const [journeyThisStationData, setJourneyThisStationData] = useState(undefined);
    const [journeyThisStationArrival, setJourneyThisStationArrival] = useState(undefined);
    const [journeyStock, setJourneyStock] = useState(undefined);
    const [isArrival, setIsArrival] = useState(false);
    const [showStops, setShowStops] = useState(false);
    useEffect(() => {
        getJourney(partialData.product.number, onFetched);
        setShowStops(false);
    }, [partialData.product.number]);

    function onFetched(d){
        console.info("Departure item fetched");
        const parsed = JSON.parse(d.target.response).payload;
        setData(parsed);
        if(partialData.origin == "Uitgeest") console.log(parsed);
        if(partialData.direction == "Uitgeest") console.log(parsed);
        const thisStationData = parsed.stops.find(x => x.id === thisStationCode || x.id === thisStationCode + "_0");
        if(!thisStationData){
            console.error("NO SPECIFIC STATION DATA FOR JOURNEY");
            throw new Exception();
        } else {
            setJourneyThisStationData(thisStationData.departures[0]);
            if(thisStationData.departures.length == 0){
                setIsArrival(true);
                setJourneyThisStationData(thisStationData.arrivals[0]);
            } else {
                setIsArrival(false);
            }
            setJourneyThisStationArrival(thisStationData.arrivals[0]);
            setJourneyStock(thisStationData.actualStock);
        }
    }

    function toggleShowStops(){
        setShowStops(!showStops);
    }

    function getCrowdColor(crowd){
        switch(crowd){
            case "LOW": return "green";
            case "MEDIUM": return "orange";
            case "HIGH": return "red";
            default: return "gray";
        }
    }

    function getTimeOfDay(string){
        let date = new Date(string);
        let hours = date.getHours();
        if(hours < 10) hours = "0" + String(hours);
        let minutes = date.getMinutes();
        if(minutes < 10) minutes = "0" + String(minutes);
        return hours + ":" + minutes;
    }

    function getDelayString(seconds){
        let num = parseInt(seconds);
        let secondsCount = seconds % 60;
        // if(secondsCount == 0) secondsCount = "00";
        if(secondsCount < 10) secondsCount = "0" + String(secondsCount)
        return Math.floor(seconds/60) + ":" + secondsCount;
    }

    function getDepartureInfo(){
        if(!partialData){
            return "";
        }
        if(partialData.messages.length == 0){
            if(partialData.cancelled) return "Cancelled";
            if(partialData.routeStations != undefined){
                return "Via " + partialData.routeStations.map(x => x.mediumName).join(", ");
            } else {
                return "Arrival"
            }
            // return "Test"
        } else {
            return partialData.messages.map(x => x.message).join(" - ");
        }
    }

    function getInfoColor(){
        if(partialData.cancelled || partialData.messages[0]?.style == "WARNING"){
            return "red";
        } else {
            return "darkslategray"
        }
    }

    return (
        <div className="DepartureItem">
            <div className="DepartureItemHeader">
                <p className="DepartureItemHeaderName" onClick={toggleShowStops} style={{color:!partialData.cancelled ? "black" : "lightgray"}}>{partialData.direction ? partialData.direction : (partialData.origin + " (Arrival)")}</p>
                <div className="DepartureItemHeaderRight">
                    {partialData.recognizableDestination && (<div className="ViaRecognizable">
                        <p className="ViaRecognizableText">Via {partialData.recognizableDestination.name}</p>
                    </div>)}

                    <div className="DepartureItemCrowdedness" style={{backgroundColor: journeyThisStationData ? getCrowdColor(journeyThisStationData.crowdForecast): "gray"}}>
                    </div>

                    {journeyThisStationData && (
                        <p className="DeparturePlatform"
                            style={journeyThisStationData.plannedTrack === journeyThisStationData.actualTrack
                                ? {color: "black"} : {color: "red"}}>
                            {journeyThisStationData.actualTrack}
                        </p>
                    )}

                </div>
            </div>
            <div className="DepartureItemMiddle">
                <div className="DepartureItemTimesWrapper">
                    <div className="DepartureItemArrivalTime" style={{color:(journeyThisStationArrival?.delayInSeconds != undefined) ? "darkblue" : "lightgray"}}>
                        {(journeyThisStationArrival) && (<p className="DepartureItemArrivalTimes">
                            A: {getTimeOfDay(journeyThisStationArrival.plannedTime)}
                        </p>)}
                        {(journeyThisStationArrival?.delayInSeconds) ? (<p className="DepartureItemArrivalDelay">
                            +{getDelayString(journeyThisStationArrival.delayInSeconds)}
                        </p>): null}
                    </div>
                    <div className="DepartureItemDepartureTime" style={{color:(journeyThisStationData?.delayInSeconds != undefined) ? "darkblue" : "lightgray"}}>
                        {(journeyThisStationData && !isArrival) && (<p className="DepartureItemDepartureTimes">
                            D: {getTimeOfDay(journeyThisStationData.plannedTime)}
                        </p>)}
                        {(journeyThisStationData?.delayInSeconds && !isArrival) ? (<p className="DepartureItemDepartureDelay">
                            +{getDelayString(journeyThisStationData.delayInSeconds)}
                        </p>):null}
                    </div>

                </div>
                <p className="DepartureInfo" style={{color:getInfoColor()}}>
                    {getDepartureInfo()}
                </p>
            </div>
            <div className="DepartureItemBottom">
                {/* {journeyThisStationData && journeyStock && (<ScrollableTrain units={journeyStock.trainParts}/>)} */}
                {
                    (() => {
                        if(thisStationCode == "NWK"){
                            return journeyThisStationData && journeyStock && (<TrainOnPlatform trainData={ data.stops.find(x => x.id === thisStationCode || x.id === thisStationCode + "_0")}/>)
                        } else {
                            return journeyThisStationData && journeyStock && (<ScrollableTrain units={journeyStock.trainParts}/>)
                        }
                    })()
                    
                }
                {/* {journeyThisStationData && journeyStock && (<TrainOnPlatform trainData={ data.stops.find(x => x.id === thisStationCode || x.id === thisStationCode + "_0")}/>)} */}
            </div>
            {showStops ? (<JourneyStops journeyData={data?.stops}/>): null}
            
            
        </div>
    )
}